import { ContentFieldType } from "../../../types/cms/contentField.type";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { parseLiteralImageUrl } from "../internal/literalImage";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { ExtractedImage, InterpolateParams } from "../types";

/**
 * Extrai `ExtractedImage` de um template single-token `{{path|image}}`.
 * Retorna `undefined` se o template não for single-token, o tipo não for
 * `|image`, ou o valor não estiver presente.
 */
export function extractImage({
  structure,
  template,
}: InterpolateParams): ExtractedImage | undefined {
  const resolved = resolveConditionals({ template, structure });
  const match = resolved.match(SINGLE_TOKEN_REGEX);

  if (!match) {
    const literal = parseLiteralImageUrl(resolved);
    return literal ? { src: literal, alt: "" } : undefined;
  }

  const [, path, type] = match;
  if (type !== ContentFieldType.IMAGE) return undefined;

  const value = resolvePath(structure, path);
  if (value == null) return undefined;

  if (typeof value === "string") {
    return value.trim() === "" ? undefined : { src: value, alt: "" };
  }

  if (typeof value !== "object" || Array.isArray(value)) {
    return undefined;
  }

  return value as ExtractedImage;
}
